import { CLASS_ASIDE_PANEL } from '../../constants';

export const CLASS_ASIDE_PANEL_TITLE_ACTION = CLASS_ASIDE_PANEL + '__title-action';
